import { Component, OnInit } from '@angular/core';
import { AuthService } from '@services/http/auth.service';
import { UserService } from '@services/http/user.service';

import { CachedDataService } from '@services/data/cached-data.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ScreenService } from '@services/screen.service';
import { regexValidators } from '../../../validator';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignUpComponent implements OnInit {
  signUpForm: FormGroup;
  showConfirm = false;
  isConfirmCodeSend = false;
  btnText = {
    text: 'Зарегистрироваться',
    default: 'Зарегистрироваться',
    loadText: 'Отправка..'
  };
  errorMessage = '';
  errorConfirmPassword = {
    status: true,
    message: ''
  };
  errorPassword = null;
  passwordHasNumAndChar = true;

  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    private authService: AuthService,
    private cachedDataService: CachedDataService,
    private screenService: ScreenService) {

  }

  confirmCodeEvent() {
    this.errorMessage = '';
  }

  ngOnInit() {
    this.screenService.isShowLoader = false;
    this.initForm();
    if (this.cachedDataService.getCurrentUser() && !this.cachedDataService.getCurrentUser().phoneNumberConfirmed) {
      this.showConfirm = true;
      const currentUser = this.cachedDataService.getCurrentUser();
      this.signUpForm.controls['username'].setValue(currentUser.userName);
      this.signUpForm.controls['email'].setValue(currentUser.email);
      this.signUpForm.controls['fullname'].setValue(currentUser.fullName);
      this.signUpForm.controls['password'].setValue(this.cachedDataService.getCredentials().password);
      this.signUpForm.controls['confirmPassword'].setValue(this.cachedDataService.getCredentials().password);
      this.btnText.text = 'Отправить код';
    }
  }


  initForm() {
    this.signUpForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.pattern(regexValidators.email)]],
      fullname: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required]],
      accept: [false, [Validators.required]]
    });
  }

  checkPassword() {
    const passLength = this.signUpForm.value.password.length;
    const password = this.signUpForm.value.password;

    if (passLength > 0) {
      if (this.signUpForm.get('password').errors &&
        this.signUpForm.get('password').errors.minlength &&
        this.signUpForm.get('password').errors.minlength.actualLength < this.signUpForm.get('password').errors.minlength.requiredLength) {
        this.errorPassword = `Пароль слишком короткий, ${passLength} символов`;
      } else {
        this.errorPassword = null;
      }
    } else {
      this.errorPassword = null;
    }
    if (/[a-zA-Z]/gi.test(password) && /[0-9]/gi.test(password)) {
      /*должен содержать хоть 1 символ и 1 цифру */
      this.passwordHasNumAndChar = true;
    } else {
      this.passwordHasNumAndChar = false;
    }


    if (passLength > 0 && this.signUpForm.value.confirmPassword.length > 0) {
      if (this.signUpForm.value.password !== this.signUpForm.value.confirmPassword) {
        this.errorConfirmPassword.status = false;
        this.errorConfirmPassword.message = 'Подтверждение не совпадает с паролем';
      } else {
        this.errorConfirmPassword.status = true;
        this.errorConfirmPassword.message = 'Подтверждение совпадает с паролем';
      }
    } else {
      this.errorConfirmPassword.message = '';
    }
  }

  signUp() {
    this.errorMessage = '';
   
    if (this.cachedDataService.getCurrentUser() && !this.cachedDataService.getCurrentUser().phoneNumberConfirmed) {
      this.btnText.text = this.btnText.loadText;
      this.sendConfirmCode();
    } else {
      if (this.signUpForm.invalid) {
        const controls = this.signUpForm.controls;
        Object.keys(controls)
          .forEach(controlName => controls[controlName].markAsTouched());
        return;
      }
      if (!this.errorConfirmPassword.status) {
        return false;
      }
      if (!this.passwordHasNumAndChar) {
        return false;
      }
      if(!this.signUpForm.value.accept){
        this.errorMessage = 'Необходимо принять условия';
        return false;
      }
      const userDateTimeOffset = (new Date().getTimezoneOffset() / 60) * -1;

      this.btnText.text = this.btnText.loadText;
      this.authService.signUp(
        this.signUpForm.value.username.replace(/\D/g, ''),
        this.signUpForm.value.password,
        this.signUpForm.value.fullname,
        this.signUpForm.value.username.replace(/\D/g, ''),
        this.signUpForm.value.email,
        userDateTimeOffset
      )
        .then((response) => {
          this.cachedDataService.setCredentials(this.signUpForm.value);
          this.cachedDataService.setToken(response.token);
          this.cachedDataService.setCurrentUser(response.user);
          this.cachedDataService.setExpiredDate(false);
          this.sendConfirmCode();
        })
        .catch((error: any) => {
          this.btnText.text = this.btnText.default;
          if (error) {
            if (error.error.errorMessage.length) {
              this.errorMessage = error.error.errorMessage;
            } else {
              const errors = error.error.modelState;
              for (error in errors) {
                this.signUpForm.controls[errors[error].field.toLowerCase()].setErrors({ 'error': errors[error].errors });
              }
            }
          }

        });
    }
  }

  onChangeUsername(value) {
    this.signUpForm.controls['username'].setValue(value);
  }

  sendConfirmCode() {
    this.userService.sendCode(this.cachedDataService.getCurrentUser().userName)
      .subscribe(
        response => {
          this.isConfirmCodeSend = true;
          this.btnText.text = 'Отправить код повторно';
          this.errorMessage = 'SMS отправлено';
          this.showConfirm = true;
        },
        error => {
          this.errorMessage = 'Ошибка';
        });
  }

}



// WEBPACK FOOTER //
// ./src/app/view/auth/signup/signup.component.ts